var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58008 3.625L5.75977 5.80469C5.8125 5.85742 5.8125 5.94531 5.75977 6.01562L5.37305 6.40234C5.30273 6.45508 5.21484 6.45508 5.16211 6.40234L4.79297 6.0332L3 4.22266L0.820312 6.40234C0.767578 6.45508 0.679688 6.45508 0.609375 6.40234L0.222656 6.01562C0.169922 5.94531 0.169922 5.85742 0.222656 5.80469L2.40234 3.625L0.222656 1.46289C0.169922 1.41016 0.169922 1.32227 0.222656 1.25195L0.609375 0.865234C0.679688 0.8125 0.767578 0.8125 0.820312 0.865234L3 3.04492L5.16211 0.865234C5.21484 0.8125 5.30273 0.8125 5.37305 0.865234L5.75977 1.25195C5.8125 1.32227 5.8125 1.41016 5.75977 1.46289L5.39062 1.83203L3.58008 3.625Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.1eb882c5.svg";
export { ForwardRef as ReactComponent };